import { defineStore } from 'pinia'
import moment from 'moment'
// import { sortBy, reverse } from 'lodash'
import repositoryFactory from '@/factories/repository-factory'
import HistoryRepository from '@/repositories/history-repository'
import { HistoryItem } from '@/models/History'
import { rangeToISO } from '@/lib/formatter'

const storeKey = 'rain_detail'

const SPANS = {
  hour: 10,
  day: 60,
  month: 60 * 24,
} as const

export const useRainDetailStore = defineStore(storeKey, {
  state: () => ({
    hour: [] as HistoryItem[],
    day: [] as HistoryItem[],
    month: [] as HistoryItem[],
  }),

  actions: {
    async fetch(stationId: string, time = '') {
      const endTime = moment(time).add(-1, 'minute').format('YYYY-MM-DD HH:mm:ss')
      const paramsDefault = {
        stationId,
        target: ['move_rain_min_10', 'move_rain_min_60', 'rain_day'],
      }
      const resolutions = ['hour', 'day', 'month']

      resolutions.forEach(async resolution => {
        const startTime = moment(time)
          .add(-SPANS[resolution as keyof typeof SPANS] * 7 - 1, 'minutes')
          .format('YYYY-MM-DD HH:mm:ss')
        const range = rangeToISO({ startTime, endTime } as Range)
        const params = {
          ...paramsDefault,
          ...{
            range: {
              ...range,
              type: resolution,
            },
          },
        }
        const repository = (await repositoryFactory.create()).get('history') as HistoryRepository
        const response = await repository.get(params)
        const items = response.items.splice(response.items.length - 6, response.items.length)

        if (resolution === 'hour') {
          this.hour = items
        } else if (resolution === 'day') {
          this.day = items
        } else {
          this.month = items
        }
      })
    },
  },
})
